import {NotificationsSubscriptionsMenu} from '@github-ui/notifications-subscriptions-menu'
import {RepoTemplateIcon} from '@primer/octicons-react'
import {StarButton} from '@github-ui/repo-star-button'
import {Button} from '@primer/react'

import type {HeaderResponse, RepoPaths} from '../types'

export type CodeViewHeaderActionsProps = Pick<
  HeaderResponse,
  | 'repo'
  | 'forksCount'
  | 'stargazerCount'
  | 'showSponsorButton'
  | 'showTemplateButton'
  | 'star'
  | 'fork'
  | 'pin'
  | 'watch'
  | 'viewer'
> & {
  paths: RepoPaths
}

/** Desktop action button container with Watch, Fork, and Star buttons. */
export function CodeViewHeaderActions({
  repo,
  watch,
  star,
  viewer,
  paths,
  stargazerCount,
  showTemplateButton,
}: CodeViewHeaderActionsProps) {
  return (
    <ul className="list-style-none d-flex flex-items-center gap-2 flex-shrink-0 py-1" data-testid="repo-header-actions">
      {viewer.isLoggedIn && watch.canWatch && (
        <li>
          <NotificationsSubscriptionsMenu
            repositoryId={watch.watchData.repositoryId}
            repositoryName={watch.watchData.repositoryName}
            watchersCount={watch.watchData.watchersCount}
            subscriptionType={watch.watchData.subscriptionType}
            subscribableThreadTypes={watch.watchData.subscribableThreadTypes}
            repositoryLabels={watch.watchData.repositoryLabels}
            showLabelSubscriptions={watch.watchData.showLabelSubscriptions}
            subscribedLabelIds={watch.watchData.subscribedLabelIds}
            subscribedLabels={[]}
          />
        </li>
      )}

      <li>
        <StarButton
          starred={star.viewerHasStarred}
          starCount={stargazerCount}
          starPath={paths.starPath}
          unstarPath={paths.unstarPath}
          canStar={star.canStar}
          isLoggedIn={viewer.isLoggedIn}
          listsApiPath={paths.listsApiPath}
          listsUpdatePath={paths.listsUpdatePath}
          repoNameWithOwner={paths.repoNameWithOwner}
          emuContributionBlocked={viewer.emuContributionBlocked}
        />
      </li>

      {showTemplateButton && repo.isTemplate && (
        <li>
          <Button
            as="a"
            href={paths.templatePath}
            variant="primary"
            size="small"
            leadingVisual={RepoTemplateIcon}
            data-testid="use-template-button"
          >
            Use this template
          </Button>
        </li>
      )}
    </ul>
  )
}
